import { gql } from '@apollo/client';

export const ANIMAL_GROUP_HEADER_QUERY = gql`
  query AnimalGroupHeader_Query($barnId: uuid!) {
    animal_group(
      where: { deleted_at: { _is_null: true }, barn_id: { _eq: $barnId } }
      order_by: [{ ended_at: desc_nulls_first }, { external_id: asc }]
    ) {
      id
      external_id
      approximate_birthdate
      ended_at
      expected_ended_at
      started_at
      peak_inventory
      latest_inventory
    }
  }
`;

export const END_ANIMAL_GROUP_MUTATION = gql`
  mutation EndAnimalGroup($id: uuid!, $ended_at: bigint!) {
    update_animal_group_by_pk(pk_columns: { id: $id }, _set: { ended_at: $ended_at }) {
      id
      ended_at
    }
  }
`;
